import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Select } from '@bingads-webui-react/primitive-validation';
import { LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { useValidationI18n } from '../hooks';

export const UserCountrySelector = ({
  i18n, onUserCountryChange, userCountryList, userCountryCode, alwaysShowError, isOptional, disabled,
}) => {
  const validationI18n = useValidationI18n();
  const onChangeHandler = ({ target: { value: selectedCountryCode } }) => {
    onUserCountryChange({
      selectedCountryCode,
    });
  };

  return (
    <LineByLineFormGroup
      contentColClass={classnames('col-xs-6', 'user-location-control')}
      id="user-country-selector"
      className="country-selector"
      label={i18n.getString(_TL_('Country or region'))}
    >
      <Select
        value={userCountryCode}
        onChange={onChangeHandler}
        validationProps={{
          i18n: validationI18n,
          alwaysShowError,
          field: 'userCountryCode',
          data: { userCountryCode },
          schema: {
            properties: {
              userCountryCode: {
                type: 'string',
                required: !isOptional,
              },
            },
          },
        }}
        disabled={disabled}
        aria-label={i18n.getString(_TL_('Country or region'))}
      >
        <option value="" key="choose" hidden>{i18n.getString(_TL_('Choose...'))}</option>
        {userCountryList.map(c => <option value={c.Code} key={c.Code}>{c.Name}</option>)}
      </Select>
    </LineByLineFormGroup>
  );
};

UserCountrySelector.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  userCountryList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onUserCountryChange: PropTypes.func.isRequired,
  alwaysShowError: PropTypes.bool.isRequired,
  userCountryCode: PropTypes.string,
  isOptional: PropTypes.bool,
  disabled: PropTypes.bool,
};

UserCountrySelector.defaultProps = {
  userCountryCode: null,
  isOptional: false,
  disabled: false,
};
